import { useEffect, useRef } from 'react';

const useDebouncedEffect = (callback, delay, dependencies = [], skipFirst = false) => {

  const timeoutRef = useRef();
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (skipFirst && isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    timeoutRef.current = setTimeout(() => {
      callback();
    }, delay);

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [...dependencies]);
};

export default useDebouncedEffect;